import type { SettingsSubviewProps } from './Settings.types';
import type { LanguageType } from '../../utils/types';
import type { ReactElement } from 'react';

import { Flex, ScrollArea } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EXPIRATION_LOCALE_COOKIE_DAYS, Languages, LOCALE_COOKIE } from '../../constants/i18n';
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import { updateLanguage } from '../../state/SettingsSlice';
import { updateWidgetConfig } from '../../state/WidgetSlice';
import { setCookie } from '../../utils/generalFunctions/common';

import styles from './Settings.module.css';
import { SettingsOption } from './Settings.Option';
import { SettingsSubviewHeader } from './Settings.SubviewHeader';

export function SettingsLanguages(props: SettingsSubviewProps): ReactElement {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const currentLanguage = useAppSelector((state) => state.settings.language);

  const handleChangeLanguage = (newLocale: LanguageType['value']) => {
    if (!newLocale) {
      return;
    }
    setCookie(LOCALE_COOKIE, newLocale, EXPIRATION_LOCALE_COOKIE_DAYS);
    dispatch(updateLanguage(newLocale));
    dispatch(updateWidgetConfig({ language: newLocale }));
  };

  return (
    <Flex direction="column" gap="3">
      <SettingsSubviewHeader
        title={t('Language')}
        backButtonId="settings-language-back-btn"
        onBack={props.onBack}
      />
      <ScrollArea type="auto" scrollbars="vertical" size="1" className={styles.languageScrollArea}>
        <Flex direction="column" gap="2" p="2">
          {Languages.map(({ value, title, englishTitle, Icon }) => (
            <SettingsOption
              key={value}
              id={`settings-language-${value}-item`}
              title={title}
              description={englishTitle}
              selected={currentLanguage === value}
              onSelect={() => handleChangeLanguage(value)}
              media={
                <span className={styles.optionFlag}>
                  <Icon />
                </span>
              }
            />
          ))}
        </Flex>
      </ScrollArea>
    </Flex>
  );
}
